import { createRouter } from '@tanstack/react-router';
import type { RouterContext } from './routeTree';
import { routeTree } from './routeTree';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: {
    auth: {
      tokenState: 'NOT_LOADED',
      isTokenLoading: true,
      redirectUri: undefined,
    },
    me: null,
  } satisfies RouterContext,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
